import { Component, OnInit, Input } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Honor } from 'src/app/shared/models/user';
import { MobileUiService } from 'src/app/shared/services/mobile-ui.service';

@Component({
  selector: 'app-profile-honor',
  templateUrl: './profile-honor.component.html',
  styleUrls: ['./profile-honor.component.scss']
})
export class ProfileHonorComponent implements OnInit {
  @Input() honors = new BehaviorSubject<Honor[]>([]);
  honorsHeadElements = ['Title', 'Year', 'Org'];
  isMobile = new BehaviorSubject<boolean>(false);

  constructor(private mobileUiService: MobileUiService) {
    this.isMobile = this.mobileUiService.isMobile;
  }

  ngOnInit(): void {
  }

}
